var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "text-caption text-secondary--text",
      attrs: { "data-qa": "practice_updated_date" },
    },
    [
      _vm._v(
        "\n  Данные обновлены " +
          _vm._s(_setup.context.doctor_practice.dt_updated) +
          "\n"
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }